import { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(duration);
dayjs.extend(relativeTime);

const FutureDateCounter = (props: any) => {
  const [counter, setCounter] = useState("");

  useEffect(() => {
    const startTime = dayjs();
    const currentTime = dayjs(props.date);
    const elapsedTime = currentTime.diff(startTime);

    const duration = dayjs.duration(elapsedTime);
    const days = duration.asDays();
    let formattedTime: any;

    if (startTime.isAfter(currentTime)) {
      formattedTime = "0:00:00";
    } else if (days >= 1) {
      const hours = Math.floor(days * 24);
      formattedTime = `${hours}:${duration.format("mm:ss")}`;
    } else {
      formattedTime = duration.format("H:mm:ss");
    }
    const interval = setInterval(() => {
      setCounter(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, props.date]);

  return <span>{counter}</span>;
};

export default FutureDateCounter;
